<template>
  <div>
    <b-card class="bg-search" full-screen>
      <b-container class="py-5 px-lg-5">
        <div class="pb-3">
          <b-card >
            <b-row>
              <b-col class="col-12 col-md-6 col-lg-6 content-left">
                <b-row>
                  <b-col class="col-sm-12">
                    <b-form-group label="ประเภทลูกค้า :" label-cols-md="4" label-class="py-0">
                      <b-form-radio-group
                        v-model="customerType"
                        :options="this.customerTypeList"
                        text-field="label"
                        value-field="id"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group label="ประเภทสินค้า :" label-cols-md="4" label-class="py-0">
                      <b-form-radio-group
                        v-model="productType"
                        :options="this.productTypeList"
                        text-field="label"
                        value-field="id"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group label="น้ำหนักสินค้า :" label-cols-md="4">
                      <div class="d-flex align-items-center">
                        <b-form-input
                          class="col-lg-3 col-md-5"
                          v-model="weight"
                          type="number"
                          @keyup.enter="$refs.cubic1.focus"
                        />
                        <span class="pl-1">Kg.</span>
                      </div>
                      <small v-if="this.valWeight == false" class="text-danger">กรุณาระบุน้ำหนักสินค้า</small>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group label="ขนาดสินค้า :" label-cols-md="4">
                      <div class="d-lg-flex">
                        <div class="d-md-flex align-items-center">
                          <b-form-input
                            ref="cubic1"
                            class="col-md-5"
                            v-model="cubic1"
                            placeholder="กว้าง"
                            type="number"
                            @keyup.enter="$refs.cubic2.focus"
                          />
                          <span class="px-md-1">x</span>
                          <b-form-input
                            ref="cubic2"
                            class="col-md-5"
                            v-model="cubic2"
                            placeholder="ยาว"
                            type="number"
                            @keyup.enter="$refs.cubic3.focus"
                          />
                        </div>
                        <div class="d-md-flex align-items-center pr-0 pt-md-1 pt-lg-0">
                          <span class="pr-md-1">x</span>
                            <b-form-input
                              ref="cubic3"
                              class="col-lg-9 col-md-5"
                              v-model="cubic3"
                              placeholder="สูง"
                              type="number"
                              @keyup.enter="calculateCost()"
                            />
                        </div>
                      </div>
                      <div class="pb-2 pt-1"> = {{format_decimal((this.cubic1*this.cubic2*this.cubic3)/1000000)}} คิว</div>
                      <b-button variant="primary" @click="calculateCost">คำนวนค่าใช้จ่าย</b-button>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="col-12 col-md-6 col-lg-6 pt-2 pt-md-0">
                <hr>
                <div class="h4 font-weight-bolder text-md-center">
                  สรุปยอดค่าใช้จ่ายเบื้องต้น
                </div>
                <hr>
                <div v-if="this.description">
                  <div v-for="(text, i) in description" :key="i" >
                  {{text}}
                  </div>
                  <br>
                  <div v-for="(text, i) in recomendation" :key="'A' + i">
                    {{text}}
                  </div>
                  <br>
                  <div v-for="(text, i) in suggestion" :key="'B' + i">
                    {{text}}
                  </div>
                </div>
                <div v-else class="text-center pt-md-2" style="color:gray">ยังไม่มีข้อมูล</div>
              </b-col>
            </b-row>
          </b-card>
        </div>
      </b-container>
    </b-card>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BCard, BCardBody, BFormSpinbutton, BSpinner, BImg,
  BLink, BFormRadioGroup, BContainer, BNav, BNavItem, BNavbarNav, BAvatar
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { isUserLoggedIn } from '@/auth/utils'
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.us'
import useJwt from '@/auth/jwt/useJwt'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import { taobaoService_dotnet   } from '@/views/global'
import axios from 'axios'
import { header_token } from '@/views/token'
import { format_decimal } from '@/views/global_function.js'
export default {
  name: 'Taobao2youCalculate',
  components: {
    BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BCard, BCardBody, BFormSpinbutton, BSpinner, BImg,
    BLink, BFormRadioGroup, BContainer, BNav, BNavItem, BNavbarNav, BAvatar,
    //input
    Cleave
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      //detail
      customerType: 1,
      customerTypeList: [
        { id: 1, label: 'ฝากนำเข้าอย่างเดียว' },
        { id: 2, label: 'ฝากสั่ง+นำเข้า' }
      ],
      productType: 1,
      productTypeList: [
        { id: 1, label: 'สินค้าทุกประเภท' }
      ],
      weight: null,
      cubic1: null, //กว้าง
      cubic2: null, //ยาว
      cubic3: null, //สูง
      cubic: 0,
      description: null,
      recomendation: null,
      suggestion:null,
      valWeight: true,

    };
  },

  methods: {
    format_decimal,
    async calculateCost () {
      if (this.weight == null || this.weight == '' || this.weight == 0) {
        this.valWeight = false
      } else {
        let response = await axios.post(
          taobaoService_dotnet + 'api/General/calculate-price',
          {
            "weight": Number(this.weight),
            "cubic1": Number(this.cubic1) != 0 ? Number(this.cubic1) : null,
            "cubic2": Number(this.cubic2) != 0 ? Number(this.cubic2) : null,
            "cubic3": Number(this.cubic3) != 0 ? Number(this.cubic3) : null,
            "transportTypeID": 0,
            "productCategory": this.productType,
            "customerType": this.customerType
          },
          { headers: header_token }
        );
        this.description = response.data.description.split('<br/>')
        this.recomendation = response.data.recomendation.split('<br/>')
        this.suggestion = response.data.suggestion.split('<br/>')
      }
    }
  },
};
</script>

<style>
.bg-search{
  background-image: url('https://s3-ap-southeast-1.amazonaws.com/taobao2yous3/tb2uuploads/images/bg-image-1.jpg'); 
  display: block;
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: auto;
}
@media (min-width: 576px) {
  .content-left {
    border-right: 1px solid #000000;
  }
}

</style>